//Install
import React, { Component } from "react";

//Element
class Menu extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement( "ul", { className: "S0u16d C96Q4r U080Kf pEO064 a527eB o437xv" },
            //Element
            React.createElement( "li", { className: "S6pt64" },
                //Element
                React.createElement( "a", { className: "S6pt64", href: "/" },
                    //Element
                    "Türkiye"
                )
            ),
            //Element
            React.createElement( "li", { className: "S6pt64" },
                //Element
                React.createElement( "a", { className: "S6pt64", href: "/en" },
                    //Element
                    "United Kingdom"
                )
            ),
            //Element
            React.createElement( "li", { className: "S6pt64" },
                //Element
                React.createElement( "a", { className: "S6pt64", href: "/az" },
                    //Element
                    "Azerbaijan"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Menu;